import PropTypes from 'prop-types'
import { KeyboardDatePicker, DatePicker } from '@material-ui/pickers'
import { ThemeProvider } from '@material-ui/core/styles'

import { endOfToday } from 'date-fns/endOfToday'
import overrideTheme from 'theming/overrides/form/datePicker'

const FormDatePicker = ({ value, allowEmptyValue = false, noKeyboard = false, ...props }) => {
  const Component = noKeyboard ? DatePicker : KeyboardDatePicker
  return (
    <ThemeProvider theme={overrideTheme}>
      <Component
        variant="inline"
        inputVariant="outlined"
        format="MM/dd/yyyy"
        margin="normal"
        value={value || (allowEmptyValue ? null : endOfToday())}
        disableToolbar
        autoOk
        {...props}
      />
    </ThemeProvider>
  )
}
FormDatePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
}
FormDatePicker.defaultProps = {
  label: '',
  value: '',
}

export default FormDatePicker
